import { useEffect, Component } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/components/Landing";
import Confirmation from "@/components/Confirmation";
import { PaymentSuccess, PaymentCancel } from "@/components/Payment";
import Owner from "@/components/Owner";

function RouteTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", { page_path: pathname + search, page_title: document.title });
    }
  }, [pathname, search]);
  return null;
}

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/confirmation" element={<Confirmation />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/owner" element={<Owner />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-cream p-8 text-center">
          <div>
            <p className="font-display text-3xl text-espresso">Something went wrong.</p>
            <button
              data-testid="error-reload-button"
              className="mt-4 rounded-full bg-espresso px-6 py-2 text-sm text-cream"
              onClick={() => window.location.reload()}
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <RouteTracker />
        <AppRouter />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;